import { Link } from 'react-router-dom';
import { routeBase } from '../api/collections';

/**
 * A link, or a page, that answers nothing for this person: revoked, reset,
 * paused (Private), gone, or private to somebody else's workspace. One answer
 * for all of them, so it tells a stranger nothing about which.
 *
 * `signinTo` (an app path) offers sign-in and comes back there: a paused link
 * still opens for a member of the item's workspace.
 */
export function NotAvailable({
  signinTo,
  inShell,
  title = 'This link is not available',
  detail = 'It may have been reset, or what it points to is no longer shared. Ask whoever sent it for a new link.',
}: {
  signinTo?: string;
  inShell?: boolean;
  title?: string;
  detail?: string;
}) {
  const base = import.meta.env.BASE_URL.replace(/\/+$/, '');
  return (
    <div
      style={{
        flex: 1,
        minHeight: inShell ? undefined : '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: 40,
        textAlign: 'center',
        background: inShell ? undefined : 'var(--tr-page)',
        color: 'var(--tr-ink)',
        fontFamily: "'Instrument Sans', system-ui, sans-serif",
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'center', maxWidth: 420 }}>
        <span style={{ fontSize: 15, fontWeight: 600 }}>{title}</span>
        <span style={{ fontSize: 13.5, color: 'var(--tr-muted, #6b6b70)', lineHeight: 1.45 }}>{detail}</span>
        {signinTo ? (
          <Link to={`${routeBase()}/signin?return=${encodeURIComponent(base + signinTo)}`} style={{ fontSize: 13.5, marginTop: 4 }}>
            Sign in
          </Link>
        ) : (
          <Link to={`${routeBase()}/explore`} style={{ fontSize: 13.5, marginTop: 4 }}>
            Go to Explore
          </Link>
        )}
      </div>
    </div>
  );
}
